<template>
  <v-dialog
      max-width="450"
      :persistent="false"
      v-model="dialogIsOpen"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="bar-segment"
           v-on="on"
           :class="{light: configObj.isLeftover}"
           :style="{height: percentage+'%', background: configObj.color.normal, color: textColor}">

                <span class="segment-label d-flex px-2" v-if="percentage > 5">
                    <span>
                        {{ segmentDisplayName }}
                    </span>
                    <v-spacer/>

                    <span class="bar-value" :id="`bar-value-${configObj.name}`">
                        <template v-if="!configObj.isCurrency">{{ percentage | round }}%</template>
                        <template v-if="configObj.isCurrency">{{ count | currency(publisherCurrencySymbol) }}</template>
                    </span>
                </span>

      </div>
    </template>
    <v-card>
      <v-toolbar flat dark :color="configObj.color.normal">
        <v-toolbar-title>
          {{ segmentDisplayNameLong }}
        </v-toolbar-title>
        <v-spacer/>
        <div class="font-weight-bold">
          <template v-if="!configObj.isCurrency">{{ percentage | round(1) }}%</template>
          <template v-if="configObj.isCurrency">{{ count | currency(publisherCurrencySymbol) }}</template>
        </div>
      </v-toolbar>
      <div class="pa-4">

        <template v-if="configObj.segmentType==='cost'">
          <span v-html="$t(`segmentDesc.${configObj.name}`)"></span>
        </template>
        <template v-if="configObj.segmentType==='usage'">
          <span v-html="$t(`segmentDesc.${configObj.name}`)"></span>
        </template>
      </div>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="dialogIsOpen=false">{{ $t('common.dismiss') }}</v-btn>
      </v-card-actions>


    </v-card>


  </v-dialog>
</template>

<script>
import colorHighlightedPhrase from "../colorHighlightedPhrase";
import {mapGetters, mapMutations} from 'vuex'

export default {
  components: {
    colorHighlightedPhrase,
  },
  name: "OverviewGraphicBarSegment",
  props: {
    count: Number,
    countTotal: Number,

    // from the config
    configObj: Object,

    numJournals: Number,
    numJournalsSubscribed: Number,
  },
  data() {
    return {
      dialogIsOpen: false,
    }
  },
  computed: {
    ...mapGetters([
      'publisherCurrencySymbol',
    ]),
    segmentDisplayName() {
      const map = {
        usageTurnaway: 'segments.unknown',
        usageIll: 'segments.ill',
        usageSubr: 'segments.subscription',
        usageRequested: 'segments.requested',
        usageOa: 'segments.oa',
        usageBackfile: 'segments.backfile',
        costSavings: 'segments.savings',
        costSubr: 'segments.subscription',
        costRequested: 'segments.requested',
        costIll: 'segments.ill',
      }
      const key = map[this.configObj.name]
      return key ? this.$t(key) : this.configObj.displayName
    },
    segmentDisplayNameLong() {
      const map = {
        usageTurnaway: 'segments.accessUnknown',
        usageIll: 'segments.interLibraryLoan',
        usageSubr: 'segments.titleByTitle',
        usageRequested: 'segments.requestedByMembers',
        usageOa: 'segments.oa',
        usageBackfile: 'segments.postTermination',
        costSavings: 'segments.costSavings',
        costSubr: 'segments.titleByTitleCost',
        costRequested: 'segments.requestedCost',
        costIll: 'segments.interLibraryLoan',
      }
      const key = map[this.configObj.name]
      return key ? this.$t(key) : this.configObj.displayNameLong
    },
    percentage() {
      return 100 * this.count / this.countTotal
    },
    height() {
      return Math.max(this.percentage, 5)
    },
    textColor() {
      return (this.configObj.isLeftover) ? "#000" : "#fff"
    },
    subrColor() {
      return appConfigs.colors.subr.nomal
    },
    settings() {
      return this.$store.getters.configs
    },
  }
}
</script>

<style scoped lang="scss">
.bar-segment {
  padding-left: 3px;
  /*border-top: 1px solid rgba(255, 255, 255, 0.2);*/
  border-top: 1px solid #fff;
  font-size: 13px;
  color: #333;
  /*opacity: .9;*/
  cursor: pointer;

  &.light {
    opacity: .8;
  }

  span {
    cursor: default;
  }

  &:hover {
    /*background: #333 !important;*/
    /*color: #fff !important;*/
    /*opacity: 1;*/
  }
}
</style>